// Actions
export const LOG_FETCH  = '[Log] Fetch'

// Mutations
export const LOG_META   = '[Log] meta'
export const LOG_OBTAIN = '[Log] obtain'
export const LOG_CLEAR  = '[Log] clear'
export const LOG_SET_LOADING = '[Log] set loading'
